module.exports = __webpack_public_path__ + "static/media/map-pin.4285e607.svg";